import { createSlice } from "@reduxjs/toolkit";

export const storageTimeLimitsSlice = createSlice({
  name: "storageTimeLimits",
  initialState: {
    searchCriteria: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      lockerTypeId: "-1",
    },
    storageTimeLimitsData: {},
    lockerTypeList: [],
  },
  reducers: {
    changeCriteriaValue: (state, actions) => {
      const { name, value } = actions.payload;
      state.searchCriteria[name] = value;
    },
    setStorageTimeLimitsData: (state, actions) => {
      state.storageTimeLimitsData = actions.payload;
    },
    getLockerTypeList: (state, actions) => {
      state.lockerTypeList = actions.payload;
    },
    changeStorageTimeLimitsData: (state, actions) => {
      const { name, value } = actions.payload;
      let tempStorageTimeLimitsData = { ...state.storageTimeLimitsData };
      tempStorageTimeLimitsData[name] = value;
      state.storageTimeLimitsData = tempStorageTimeLimitsData;
    },
    clearStorageTimeFeeChanges: (state, actions) => {
      state.storageTimeLimitsData = actions.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getLockerTypeList,
  changeCriteriaValue,
  setStorageTimeLimitsData,
  changeStorageTimeLimitsData,
  clearStorageTimeFeeChanges,
} = storageTimeLimitsSlice.actions;

export default storageTimeLimitsSlice.reducer;
